export var material = {
    crud: {
        html: "",
        css: ``,
        js: "",

    },
    list: {
        html: "",
        css: ``,
        js: "",

    },
    crudR: {
        html: "",
        css: ``,
        js: "",

    },
    listR: {
        html: "",
        css: ``,
        js: "",

    },
    reportR: {
        html: "",
        css: ``,
        js: "",

    },
    chartR: {
        html: "",
        css: ``,
        js: "",

    }
};







///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////                   Crud                         /////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////






material.crud.html = `<form [formGroup]="[tableName]" class="flex flex-row flex-wrap [&>*]:p-2">
    [insertCode1]
  </form>`;



    material.crud.js = `import { Component, Input, Output, EventEmitter  } from '@angular/core';
    import { RootService } from "../../../service/root.service";
    import { [tableNameCamelcase] } from "../shared/[tableName]";
    import { UntypedFormControl, UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';


    @Component({
      selector: '[tableName]',
      templateUrl: './[tableName].component.html',
      styleUrls: ['./[tableName].component.scss']
    })
    export class [tableNameCamelcase]Component {
      @Input() id = null;
      @Input() ctrlName = '[tableName]';
      @Input() operation: string = 'read';
      @Output() operationChange = new EventEmitter();
      @Input() readonly: boolean = true;
      @Output() readonlyChange = new EventEmitter();
      @Input() [tableName] = new [tableNameCamelcase]().getFormGroup();
      @Output() [tableName]Change = new EventEmitter();
      @Input('returnItems') returnItems;
      @Output('returnItemsChange') returnItemsChange = new EventEmitter();
      @Input('extraValue') extraValue;
      @Output('extraValueChange') extraValueChange = new EventEmitter();

      constructor(public root: RootService) {

      }
      ngOnInit(): void {
        this.onChanges();
      }

      onChanges(): void {

      }
      [insertCode2]
      [insertGetF]

    }
    `;















///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////                   Crud R                       /////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////









material.crudR.html = `<aCrud [(value)]="[tableName]" [ctrlName]="ctrlName" [(extraValue)]="extraValue" [(returnItems)]="returnItems" [id]="id" [(operation)]="operation" [(readonly)]="readonly">
<mat-card class="mat-elevation-z1">
  <[tableName] [([tableName])]="[tableName]" [ctrlName]="ctrlName" [(extraValue)]="extraValue" [(returnItems)]="returnItems" [id]="id" [(operation)]="operation" [(readonly)]="readonly" ></[tableName]>
</mat-card>
</aCrud>
`;

material.crudR.js = `import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RootService } from "../../../service/root.service";
import { ActivatedRoute } from '@angular/router';
import { [tableNameCamelcase] } from "../shared/[tableName]";
import { Observable } from "rxjs"
import { MatDialog } from '@angular/material/dialog';
import { AConfirmDialogComponent } from '../../../component/a-confirm-dialog/a-confirm-dialog.component';
import { ATranslateService } from '../../../service/aTranslate.service';
@Component({
  selector: '[tableName]-crud',
  templateUrl: './[tableName]-crud.component.html',
  styleUrls: ['./[tableName]-crud.component.scss']
})
export class [tableNameCamelcase]CrudComponent {

  fromRoute = false;
  id = null;
  ctrlName = '[tableName]';
  [tableName] = new [tableNameCamelcase]().getFormGroup();
  extraValue;
  returnItems;
  operation: string = 'read';
  readonly: boolean = true;
  constructor(
    public root: RootService,
    private route: ActivatedRoute,
    public aT: ATranslateService,
    public dialog: MatDialog,
  ) {
    var routeData = this.route.snapshot.data;
    if (routeData['fromRoute']) {
      this.fromRoute = routeData['fromRoute'];
    }
    if (routeData['operation']) {
      this.operation = routeData['operation'];
    }
    if (this.operation != 'read') {
      this.readonly = false;
    }
    route.paramMap.subscribe((val: any) => {
      if (val.params && val.params.id) {
        this.id = +val.params.id;
      }
    })
  }

  ngOnInit(): void {

  }


  async canDeactivate() {
    if (this.[tableName].dirty && (this.operation != 'read')) {
      const dialogRef = this.dialog.open(AConfirmDialogComponent, {
        data: {
          header: this.aT.getDirect('form.common.leave'),
          icon: 'delete',
          message: this.aT.getDirect('form.common.leaveQ'),
          buttonColor: 'warn',
        }
      });



      return await dialogRef.afterClosed().toPromise();
    }

    return true;
  }

}

`;








///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////                  List  R                       /////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////










material.listR.html = `
<[tableName]s></[tableName]s>
`;


material.listR.js = `import { Component, ViewChild } from '@angular/core';


@Component({
  selector: '[tableName]-list',
  templateUrl: './[tableName]-list.component.html',
  styleUrls: ['./[tableName]-list.component.scss']
})
export class [tableNameCamelcase]ListComponent {


}


`;







///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////                   List                         /////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////







material.list.html = `
<div class="flex flex-col flex-auto min-w-0">

    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">

        <!-- CONTENT GOES HERE -->
        <div class="">
            <aTable class="w-full" #[tableName]Atable [table]="[tableName]Table">
            <ng-template aTemplate="_form" let-value let-extraValue="extraValue" let-returnItems="returnItems"
                        let-operation="operation" let-readonly="readonly">
                <[tableName] [[tableName]]="value" [ctrlName]="[tableName]Table.tableName" [extraValue]="extraValue"
                            [returnItems]="returnItems" [operation]="operation" [readonly]="readonly">
                </[tableName]>
            </ng-template>
            <ng-template aTemplate="_card" let-data>
              <div class="p-3">
                <div class="grid grid-cols-2 gap-4">
                      <div *ngFor="let row of data;let i = index" class="">
                          <mat-card>
                              <mat-card-header>
                                  <div mat-card-avatar
                                      class="flex items-center justify-center cursor-pointer bg-gray-200 text-gray-600 uppercase"
                                      (click)="[tableName]Atable.actionBtn(row,'read',i)">
                                      {{[tableName]Atable.getItemHeader(row.name)}}
                                  </div>
                                  <!-- <mat-card-title></mat-card-title> -->
                                  <mat-card-subtitle class="capitalize">{{row.name}}</mat-card-subtitle>
                                  <div class="flex flex-1 justify-end">
                                      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="icon-button with a menu">
                                          <mat-icon>more_vert</mat-icon>
                                      </button>
                                      <mat-menu #menu="matMenu">
                                          <button mat-menu-item
                                                  *ngIf="[tableName]Atable.auth.getPagePermission('admin.'+[tableName]Table.tableName,'read')"
                                                  (click)="[tableName]Atable.actionBtn(row,'read',i)">
                                              <mat-icon svgIcon="mat_outline:remove_red_eye" class="text-primary"></mat-icon>
                                              <span>{{('form.common.view'| transloco)}}</span>
                                          </button>
                                          <button mat-menu-item
                                                  *ngIf="[tableName]Atable.auth.getPagePermission('admin.'+[tableName]Table.tableName,'update')"
                                                  (click)="[tableName]Atable.actionBtn(row,'update',i)">
                                              <mat-icon svgIcon="heroicons_outline:pencil" class="text-orange-500"></mat-icon>
                                              <span>{{('form.common.edit'| transloco)}}</span>
                                          </button>
                                          <button mat-menu-item
                                                  *ngIf="[tableName]Atable.auth.getPagePermission('admin.'+[tableName]Table.tableName,'clone')"
                                                  (click)="[tableName]Atable.actionBtn(row,'clone',i)">
                                              <mat-icon svgIcon="mat_outline:content_copy" class="text-stone-500"></mat-icon>
                                              <span>{{('form.common.clone'| transloco)}}</span>
                                          </button>
                                          <button mat-menu-item
                                                  *ngIf="[tableName]Atable.auth.getPagePermission('admin.'+[tableName]Table.tableName,'print')"
                                                  (click)="[tableName]Atable.actionBtn(row,'print',i)">
                                              <mat-icon svgIcon="mat_outline:print" class="text-green-600"></mat-icon>
                                              <span>{{('form.common.print'| transloco)}}</span>
                                          </button>
                                          <button mat-menu-item
                                                  *ngIf="[tableName]Atable.auth.getPagePermission('admin.'+[tableName]Table.tableName,'delete')"
                                                  (click)="[tableName]Atable.actionBtn(row,'delete',i)">
                                              <mat-icon svgIcon="mat_outline:delete" class="text-warn-500"></mat-icon>
                                              <span>{{('form.common.delete'| transloco)}}</span>
                                          </button>
                                      </mat-menu>
                                  </div>
                              </mat-card-header>
                              <mat-card-content>
                                  [listCardContent]
                              </mat-card-content>
                          </mat-card>
                    </div>
                </div>
              </div>
            </ng-template>
        </aTable>
      </div>

    </div>

</div>

`;


material.list.js = `import { Component } from '@angular/core';
import { AFilter } from "../../../shared/aFilter";
import { aTable } from "../../../component/a-table/a-table";
import { ATranslateService } from '../../../service/aTranslate.service';
import { [tableNameCamelcase] } from "../shared/[tableName]";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RootService } from '../../../service/root.service';

@Component({
  selector: '[tableName]s',
  templateUrl: './[tableName]s.component.html',
  styleUrls: ['./[tableName]s.component.scss']
})
export class [tableNameCamelcase]sComponent {
  constructor(
    public root :RootService,
    public aT: ATranslateService,
    private breakpointObserver: BreakpointObserver) {

    this.breakpointObserver.observe(Breakpoints.XSmall).subscribe(result => {

      if (result.matches) {
        this.[tableName]Table.type = 'card';
        this.[tableName]Table.popup = false;
      } else {
        this.[tableName]Table.type = 'table';
        this.[tableName]Table.popup = true;
      }

    });
  }
  [tableName]Table: aTable = {
    displayedColumns: [[insertCode1]'createdDate', 'action'],
    globalSearch: [
      {
        key: 'name',
        type: 'contains',
      }
    ],
    tableName: '[tableName]',
    sFilters: [
      [insertCode2]
    ],
    translate: true,
    type: 'table',
    popup: true,
    createValue: new [tableNameCamelcase]().getFormGroup(),
    createDefault: {},
    headers: {
      [insertCode3]
      createdDate: {
        type: 'date',
        lang: 'form.common.createdDate'
      },
      action: {
        type: 'action'
      }
    }
  }
}

`;






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////                   Report                       /////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////







material.reportR.html = `
<div>
    <aTable #abc [table]="table">
        <ng-template aTemplate="_form" let-value let-operation="operation" let-readonly="readonly">
            <[tableName] [[tableName]]="value" [ctrlName]="table.tableName" [operation]="operation"
                         [readonly]="readonly"></[tableName]>
        </ng-template>
    </aTable>
</div>

`;


material.reportR.js = `import { Component } from '@angular/core';

import { AFilter } from "../../../shared/aFilter";
import { aTable } from "../../../component/a-table/a-table";
import { [tableNameCamelcase] } from "../shared/[tableName]";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { RootService } from '../../../service/root.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Component({
  selector: '[tableName]-report',
  templateUrl: './[tableName]-report.component.html',
  styleUrls: ['./[tableName]-report.component.scss']
})
export class [tableNameCamelcase]ReportComponent {
  constructor(
    public root :RootService,
    private breakpointObserver: BreakpointObserver) {

    this.breakpointObserver.observe(Breakpoints.XSmall).subscribe(result => {

      if (result.matches) {
        this.table.type = 'card';
      } else {
        this.table.type = 'table';
      }

    });
  }
  activeLink='report';
  table: aTable = {
    displayedColumns: [[insertCode1]'createdDate', 'action'],
    globalSearch: [
      {
        key: 'name',
        type: 'contains',
      }
    ],
    tableName: '[tableName]',
    sFilters: [
      [insertCode2]
    ],
    sGroups: [
      [insertCode5]
      { name: 'createdDate', key: 'createdDate', type: 'date', lang: 'form.common.createdDate' },
    ],
    chartFields: [
      [insertCode4]
    ],
    translate: true,
    popup: true,
    enablePrintBtn: true,
    enableExportBtn: true,
    enableImportBtn: true,
    createValue: new [tableNameCamelcase]().getFormGroup(),
    createDefault: {},
    headers: {
      [insertCode3]
      createdDate: {
        type: 'date',
        lang: 'form.common.createdDate'
      },
      action: {
        type: 'action'
      }
    }
  }



}



`;


// Chart

material.chartR.html = `
<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
    <!-- Header -->
    <!-- <div class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-8 px-6 md:px-8 border-b"> -->
        <!-- Loader -->
        <!-- <div class="absolute inset-x-0 bottom-0" *ngIf="isLoadingResults">
            <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </div> -->
    <!-- </div> -->

    <!-- Main -->
    <div class="flex flex-auto overflow-hidden border p-2 h-160">
        <div class="flex flex-col flex-auto min-h-full border overflow-hidden sm:overflow-y-auto mat-elevation-z8">
            <!-- <div class="border border-red-500 h-full"> -->
                <aChartForm [table]="table"></aChartForm>
            <!-- </div> -->
        </div>

    </div>

</div>
`;


material.chartR.js = `
      import { Component } from '@angular/core';

      import { AFilter } from "../../../shared/aFilter";
      import { aTable } from "../../../component/a-table/a-table";
      import { [tableNameCamelcase] } from "../shared/[tableName]";
      import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
      import { RootService } from '../../../service/root.service';
      import { Observable } from 'rxjs';
      import { map } from 'rxjs/operators';
      @Component({
        selector: '[tableName]-chart',
        templateUrl: './[tableName]-chart.component.html',
        //styleUrls: ['./[tableName]-chart.component.scss']
      })
      export class [tableNameCamelcase]ChartComponent {
        table: aTable = {
          displayedColumns: [[insertCode1]'createdDate', 'action'],
          globalSearch: [
            {
              key: 'name',
              type: 'contains',
            }
          ],
          tableName: '[tableName]',
          sFilters: [
            [insertCode2]
          ],
          sGroups: [
            [insertCode5]
            { name: 'createdDate', key: 'createdDate', type: 'date', lang: 'form.common.createdDate' },
          ],
          chartFields: [
            [insertCode4]
          ],
          translate: true,
          popup: true,
          enablePrintBtn: true,
          createValue: new [tableNameCamelcase]().getFormGroup(),
          createDefault: {},
          headers: {
            [insertCode3]
            createdDate: {
              type: 'date',
              lang: 'form.common.createdDate'
            },
            action: {
              type: 'action'
            }
          }
        }
      }

`;



// WEBPACK FOOTER //
// ./src/app/module/project/shared/material.ts